import * as React from "react";

interface ITileProps {
    text: string;
    onClick: () => any;

    // Style elements, refactor?
    active: boolean;
}

interface ITileState {
    tileClass: string;
}

class Tile extends React.Component<ITileProps, ITileState> {
    private tileRef: React.RefObject<HTMLDivElement>;

    private innerTileRef: React.RefObject<HTMLDivElement>;

    constructor(props: ITileProps) {
        super(props);
        this.glow = this.glow.bind(this);
        this.state = { tileClass: "" };
        this.tileRef = React.createRef();
        this.innerTileRef = React.createRef();
    }

    public glow() {
        const { onClick } = this.props;
        this.setState({ tileClass: "active" }, () => {
            onClick();
        });
    }

    public render() {
        const { active, text } = this.props;
        const { tileClass } = this.state;
        return (
            <div ref={this.tileRef} className="Tile">
                <div
                    ref={this.innerTileRef}
                    className={`tile-inner ${active ? "active" : "inactive"
                    } ${tileClass}`}
                >
                    <div tabIndex={0} role="button" onClick={this.glow} onKeyPress={this.glow} className="tile-inner-inner">
                        {text && (
                            <p className="tile-text">{text}</p>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default Tile;
